<template>
  <TimeslotDashboardLayout>
    <div class="main-content support">
      <div>
        <div class="content-div">
          <div class="tap-heading-div">
            <h1 class="tab-heading">Support</h1>
            <div class="tab-text"></div>
            <div class="no-update_wrapper" style="display:none;">
              <div class="no-update_content">
                <img
                  src="https://uploads-ssl.webflow.com/629917a86b347b2be85e67ff/629917a86b347be87e5e6851_timer.svg"
                  loading="lazy"
                  alt=""
                />
                <div class="no-update-yet">Nothing to show here</div>
                <div class="appointments">
                  Appointments with professionals would show up here
                </div>
                <a href="#" class="explore-professionals_button w-button"
                  >Explore professionals</a
                >
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="support-wrapper">
        <div class="support-wrapper">
          <a
            href="mailto:support@timeslate.com"
            class="email-wrapper w-inline-block"
          >
            <img
              src="@/assets/timeslot-images/email.svg"
              loading="lazy"
              width="70"
              alt=""
            />
            <div class="text-block-104">
              Send us a mail
            </div>
          </a>
          <a
            href="https://www.instagram.com/timeslate__/"
            class="email-wrapper w-inline-block"
            ><img
              src="@/assets/timeslot-images/instagram-1.svg"
              loading="lazy"
              width="60"
              alt=""
            />
            <div class="text-block-104">Instagram</div>
          </a>
          <a
            href="https://twitter.com/Timeslate_"
            class="email-wrapper w-inline-block"
            ><img
              src="@/assets/timeslot-images/twitter-1.svg"
              loading="lazy"
              width="60"
              alt=""
            />
            <div class="text-block-104">Twitter</div>
          </a>
        </div>
      </div>
    </div>
    <template v-slot:right-side-nav>
      <div></div>
    </template>
  </TimeslotDashboardLayout>
</template>

<script>
import TimeslotDashboardLayout from "@/views/timeslot/TimeslotDashboardLayout";
export default {
  name: "CustomerSupport",
  components: { TimeslotDashboardLayout }
};
</script>

<style scoped></style>
